import React from "react";
import PropTypes from "prop-types";
import {
  Input,
  makeStyles,
  FormLabel,
  InputAdornment,
} from "@material-ui/core";
import { tokens } from "../../../theme/tokens";

const useStyles = makeStyles((theme) => ({
  cssLabel: {
    "&$cssFocused": {
      color: tokens.color.focus.ring,
    },
  },
  cssOutlinedInput: {
    "&$cssFocused $notchedOutline": {
      borderColor: tokens.color.focus.ring,
    },
  },
  inputIdent: {
    "& .MuiInputBase-input": {
      textIndent: "10px",
    },
  },
  cssFocused: {},
  notchedOutline: {},
}));

const FMUInputField = ({
  label,
  field,
  dollar,
  form: { dirty, touched, errors },
  ...other
}) => {
  const errorText = errors[field.name];
  const classes = useStyles();
  const hasError = dirty && touched[field.name] && errorText !== undefined;
  return (
    <Input
      inputProps={{
        classes: {
          root: classes.cssOutlinedInput,
          focused: classes.cssFocused,
          notchedOutline: classes.notchedOutline,
        },
        // format: "00.00",
        step: "any",
      }}
      // InputProps={{
      //   format: "00.00",
      // }}
      startAdornment={
        dollar && (
          <InputAdornment
            style={{
              marginTop: "1px",
              color: tokens.color.text.primary,
              "& .MuiTypographyColorTextSecondary": {
                color: tokens.color.text.primary,
              },
            }}
            position="end"
          >
            $
          </InputAdornment>
        )
      }
      autoCapitalize={"true"}
      className={classes.inputIdent}
      disableUnderline
      placeholder={label}
      error={hasError}
      {...field}
      {...other}
    />
  );
};

FMUInputField.propTypes = {
  // label: PropTypes.string.isRequired,
  field: PropTypes.shape({
    name: PropTypes.string,
    onChange: PropTypes.func,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,
  form: PropTypes.shape({
    dirty: PropTypes.bool,
    errors: PropTypes.object,
    touched: PropTypes.object,
  }).isRequired,
  fullWidth: PropTypes.bool,
  variant: PropTypes.string,
  margin: PropTypes.oneOf(["none", "dense", "normal"]),
};

FMUInputField.defaultProps = {
  fullWidth: true,
};
export default FMUInputField;
